import {
  postRequest
} from '@/utils/api'

export function listPort(params) {
  return postRequest('/api/coo/port/list', params)
}

export function getPort(id) {
  return postRequest('/api/coo/port/get', { id })
}

export function addPort(data) {
  return postRequest('/api/coo/port/add', data)
}

export function updatePort(data) {
  return postRequest('/api/coo/port/update', data)
}

export function delPort(id) {
  return postRequest('/api/coo/port/delete', { id })
}

export function pushPort(id) {
  return postRequest('/api/coo/port/push', { id })
}

export function importPort(data) {
  return postRequest('/api/coo/port/import', data)
}
